/**
 * Which key the analysis is run on. Product and SKU-prefix live in separate
 * tables (the SKU table materializes every prefix level 1-6 with a
 * prefix_length column, so a level filter is mandatory there).
 */
export type SubsequentGrain = "product" | "sku"

export const SUBSEQUENT_CUBES: Record<SubsequentGrain, string> = {
  product: "company_shopify_subsequent_purchases_product",
  sku: "company_shopify_subsequent_purchases_sku_prefix",
}

export const GRAIN_OPTIONS: Array<{ value: SubsequentGrain; label: string }> = [
  { value: "product", label: "Product" },
  { value: "sku", label: "SKU prefix" },
]

export const SKU_PREFIX_LEVELS = [1, 2, 3, 4, 5, 6] as const

// Sequence of the ORIGINAL order; the dbt model only materializes 1-4.
export const ORDER_SEQUENCE_OPTIONS = [
  { value: "1", label: "1st order" },
  { value: "2", label: "2nd order" },
  { value: "3", label: "3rd order" },
  { value: "4", label: "4th order" },
]

/** Picker lists the top-N original items by orders in the window. */
export const OPTIONS_LIMIT = 500

/** Cap on next-order rows fetched for one original item. */
export const ROW_LIMIT = 2000

export const CHART_ID = "subsequent-purchases-table"
